const PREFIJO_URL_DESCARGA = "download/";
const REGEX_URL_ABSOLUTA = /^https?:\/\//i;

/**
 * Indica si el `url` de una notificación apunta a un archivo para descargar
 * (ej: el Excel de un reporte generado de forma asíncrona) en lugar de una
 * ruta interna del SPA.
 * @param {string} url
 * @returns {boolean}
 */
export function esUrlDescarga(url) {
  if (typeof url !== "string") return false;
  return url.startsWith(PREFIJO_URL_DESCARGA) || REGEX_URL_ABSOLUTA.test(url);
}

function descargarArchivoNotificacion(url) {
  const href = REGEX_URL_ABSOLUTA.test(url) ? url : process.env.VUE_APP_BASE_URL + url;
  const link = document.createElement("a");
  link.href = href;
  link.download = url.split("/").pop() || "archivo";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * Punto único para reaccionar al click de una notificación. El backend no
 * distingue el tipo de destino en un campo aparte: lo inferimos del formato
 * del propio `url` (ver esUrlDescarga). Reportes async → descarga de archivo;
 * cualquier otra cosa → navegación interna del SPA.
 * @param {string} url
 * @param {import('vue-router').default} router
 */
export function abrirNotificacionUrl(url, router) {
  if (!url) return;
  if (esUrlDescarga(url)) {
    descargarArchivoNotificacion(url);
    return;
  }
  router.push(url);
}
